export enum WorkflowPromptSubmissionStatus {
  failure = 'Failed',
  inProgress = 'In Progress',
  success = 'Succeeded'
}
